// hvu-meta.js - HVU Meta tracking helper. Loaded after the Meta Pixel base code.
// Spec: HVU_Meta_Tracking_TechGuide.md section 2.3
(function (w) {
  var PIXEL_ID = '2419302561878695';

  // Standard event names Meta understands natively. Anything else is a custom event.
  var STANDARD = new Set(['PageView','ViewContent','Search','Lead','CompleteRegistration',
    'AddToCart','InitiateCheckout','AddPaymentInfo','Purchase','Subscribe','StartTrial']);

  function getCookie(name) {
    var m = w.document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return m ? m[2] : null;
  }

  // CAPI relay slot (guide section 5). Until the relay is configured this is a no-op
  // so the browser pixel always fires. Replace this function (Path A PostHog or
  // Path B endpoint) and every event in the guide starts sending server-side too.
  if (typeof w.hvuSendServer !== 'function') {
    w.hvuSendServer = function () { /* CAPI relay not configured yet */ };
  }

  // Fire one logical event to BOTH the browser pixel and the server relay,
  // sharing a single event_id so Meta dedupes them into one counted event.
  //
  //   eventName  - 'Lead', 'CompleteRegistration', 'DrawerOpen', etc.
  //   customData - { value, currency, content_name, content_ids, content_category }
  //   userData   - RAW (unhashed) PII: { em, fn, ln, zp, ph }. Hashing happens in the relay.
  //
  // Returns the event_id.
  w.hvuFireEvent = function (eventName, opts) {
    opts = opts || {};
    var customData = opts.customData || {};
    var userData   = opts.userData   || {};
    var eventId    = (w.crypto && w.crypto.randomUUID)
      ? w.crypto.randomUUID()
      : String(Date.now()) + '-' + Math.random().toString(16).slice(2);

    try {
      // --- Browser side: Meta Pixel ---
      if (typeof w.fbq === 'function') {
        if (Object.keys(userData).length) { w.fbq('init', PIXEL_ID, userData); }
        w.fbq(STANDARD.has(eventName) ? 'track' : 'trackCustom',
              eventName, customData, { eventID: eventId });
      }

      // --- Server side: CAPI relay ---
      w.hvuSendServer(eventName, eventId, Object.assign({}, customData, userData, {
        event_source_url: w.location.href,
        fbc: getCookie('_fbc'),   // raw - never hashed
        fbp: getCookie('_fbp')    // raw - never hashed
      }));
    } catch (e) { /* fail soft: tracking never blocks the user */ }

    return eventId;
  };
})(window);
